import React from 'react';

import { DrawerContent, DrawerFooter, DrawerHandle, DrawerHeader } from '.';

interface DrawerSideBoxProps extends React.PropsWithChildren {
  toggleDrawer: () => void;
}

export const DrawerSideBox: React.FC<DrawerSideBoxProps> = ({ toggleDrawer, children }) => (
  <>
    <DrawerHeader>WFM</DrawerHeader>
    <DrawerContent>{children}</DrawerContent>
    <DrawerHandle onClick={toggleDrawer} />
    <DrawerFooter />
  </>
);
